import { ContentfulTextNoteType } from 'ContentfulDefaults/types/_shared';

export const alexGoReviewNote: {
  alex_go_review_note: ContentfulTextNoteType[];
} = {
  alex_go_review_note: [
    {
      plan_year: '2026',
      supplemental_plan_type: null,
      short_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value: 'We can include a custom text note here up to 140 characters!',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
      long_text: {
        nodeType: 'document',
        data: {},
        content: [
          {
            nodeType: 'paragraph',
            data: {},
            content: [
              {
                nodeType: 'text',
                value: 'Additional information can go here - up to 5000 characters!',
                marks: [],
                data: {},
              },
            ],
          },
        ],
      },
      button_text: 'Read more',
    },
  ],
};
